<div class="tokens-container display-only d-flex flex-column">
    <div class="input-label txt-secondary flex-grow-1">{{ label }}</div>
    <div class="input-container d-flex align-items-center">
        <span class="tez-value" [matTooltip]="value | formatTed : 7">{{ value | formatTed }}</span
        >&nbsp;TED
    </div>
</div>
